// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import actions from '../../actions-list';
import {closeMachineStatusModal} from './machine-status-modal';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';
import {updateMachineStatus} from '../../shared/repositories';

export const approveDenyMachineStatus = (actionToTake, itemToUpdate) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        let status;

        if (actionToTake === 'APPROVE') {

            status = 'ACCEPTED';

        } else if (actionToTake === 'RETURNED') {

            status = 'RETURNED';

        } else {

            status = 'REJECTED';

        }

        const payload = new StatusChange({
            ...itemToUpdate,
            status
        });

        try {

            await updateMachineStatus(payload);

            closeMachineStatusModal()(dispatch);

            dispatch({
                id: itemToUpdate.id,
                type: actions.UPDATE_TCSM_MACHINE_STATUS_UPDATES_LIST
            });

            successAlertBar(translate(`MACHINE_STATUS_UPDATE_${status}`));

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/approve-deny-machine-status.js